interface StepConnectorProps {
  active?: boolean;
}

export const StepConnector = ({ active = false }: StepConnectorProps) => (
  <div
    className={`flex-1 h-1 rounded-full transition-all ${
      active ? "bg-progress-gradient" : "bg-theme-step-connector-inactive"
    }`}
  />
);
